import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import RadioButtonUncheckedOutlinedIcon from "@material-ui/icons/RadioButtonUncheckedOutlined";
import AddIcon from "@material-ui/icons/Add";
import ActionButton from "../general/ActionButton";
import {
  getInsContacts,
  getInsContactsInformation,
  getIsUpdating,
  getUpdateErrors,
  addInsContact,
  deleteInsContact,
  updateInsContactDefault,
  toggleInsContactsModal,
  getInsContactsStatus,
  getDefaultInsurersListSelector,
  getDefaultInsurersList,
} from "../store/brokerage";
import { getProvinceInformation } from "../store/broker";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import {
  getBrokeragesList,
  loadBrokerages,
  getSelectedBrokerage,
  brokerageSelected,
  loadUserCounts,
  getBrokeragesUserCounts,
  toggleAddBrokerageModal,
  getAddBrokerageStatus,
  addBrokerage,
} from "../store/brokerages";
import Select from "react-dropdown-select";
import { useNavigate } from "react-router-dom";

const BrokerageSuperAdminDashboard = () => {
  return <BrokerageSuperAdminDashboardPane></BrokerageSuperAdminDashboardPane>;
};

const BrokerageSuperAdminDashboardPane = () => {
  const dispatch = useDispatch();

  let history = useNavigate();

  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);

  const brokerages = useSelector(getBrokeragesList);
  let addBrokerageModalState = useSelector(getAddBrokerageStatus);
  useEffect(() => {
    dispatch(loadUserCounts());
  }, [dispatch]);

  // On operation selected
  const onChangeHandle = (value) => {
    console.log(value[0].code);
    history("/quoteyadmin/details?c=" + encodeURIComponent(value[0].code));
  };
  const onAddBrokerageClickHandle = (value) => {
    dispatch(toggleAddBrokerageModal(value));
  };
  return (
    <div
      style={{
        margin: "3.5rem",
      }}
    >
      <div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingLeft: "5%",
            paddingRight: "5%",
          }}
        >
          {}

          <div
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <div style={{ width: "80%" }}>
              <Select
                placeholder={"Search for a brokerage"}
                color={theme.COLORS.primary_navyblue}
                searchable={true}
                onChange={(values) => onChangeHandle(values)}
                values={[]}
                options={brokerages}
                style={{
                  width: "100%",
                  height: "6vh",
                  fontSize: "1.9vmin",
                  border: "5px solid white",
                  borderRadius: 15,
                  fontFamily: "GibsonRegular",
                }}
                labelField={"name"}
                valueField={"code"}
                dropdownHeight={"58vh"}
              />
            </div>
            <div>
              <Button
                style={{
                  color: "white",
                  fontFamily: "GibsonRegular",
                  fontSize: 12,
                  backgroundColor: theme.COLORS.secondary_orange,
                  marginTop: 10,
                  marginLeft: 10,
                  border: 0,
                  width: "10vw",
                  letterSpacing: 1,
                }}
                onClick={() => {
                  onAddBrokerageClickHandle(true);
                }}
              >
                Add New Brokerage
              </Button>
            </div>
          </div>
          <br />
        </div>
        <InsurerContactItems />
      </div>
      <Modal
        size="md"
        isOpen={addBrokerageModalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          content: {
            height: "82vh",
            width: "50vw",
            position: "absolute",
            top: "15vh",
            left: "25vw",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.primary_navyblue,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <AddBrokerage />
      </Modal>
    </div>
  );
};

const AddBrokerage = (props) => {
  const [provinceValue, setProvinceValue] = useState([]);
  const [name, setName] = useState(null);
  const [code, setCode] = useState(null);
  const [formIDs, setFormID] = useState(null);
  const [addr1, setAddr1] = useState(null);
  const [addr2, setAddr2] = useState(null);
  const [city, setCity] = useState(null);
  const [province, setProvince] = useState(null);
  const [postalCode, setPostalCode] = useState(null);
  const [website, setWebsite] = useState(null);
  const [phone, setPhone] = useState(null);
  const [check, setCheck] = useState(false);
  // const [insCodes, setInsCodes] = useState(null);
  const provinces = useSelector(getProvinceInformation);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDefaultInsurersList());
  }, []);
  useEffect(() => {
    if (provinces) {
      setProvinceValue(provinces.provinces);
    }
  }, [provinces]);
  let insContacts = useSelector(getDefaultInsurersListSelector);
  const onAddButtonClick = () => {
    let data = {
      name: name,
      code: code,
      formids: formIDs,
      address: {
        addr_line1: addr1,
        addr_line2: addr2,
        city: city,
        province: province,
        postal_code: postalCode,
      },
      website: website,
      contact_number: phone,
      isFOC: check,
      // insurercodes: insCodes
    };
    dispatch(addBrokerage(data)).then(
      setTimeout(() => {
        dispatch(loadBrokerages());
        // Array.isArray(updateErrors) && !updateErrors.length ? toast.success("Branch Added Successfully") : toast(updateErrors);
      }, 1000)
    );
    dispatch(toggleAddBrokerageModal(false));
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleAddBrokerageModal(value));
  };

  const onChangeHandle = (value) => {
    var insArr = [];
    value.forEach((v) => {
      insArr.push(v.code);
    });
    // setInsCodes(insArr);
  };
  const onProvinceHandle = (value) => {
    console.log(value);
    setProvince(value[0].code);
  };

  return (
    <PerfectScrollbar>
      <div style={{ verticalAlign: "middle" }}>
        <form class="m-4">
          <h3
            class="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            Add New Brokerage
          </h3>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblName" class="col-sm-4 col-form-label">
              Brokerage Name
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtName"
                placeholder="Enter Brokerage Name"
                onChange={(event) => {
                  setName(event.target.value);
                  setCode(
                    event.target.value
                      .replaceAll(" ", "")
                      .toUpperCase()
                      .replace(/[^a-zA-Z0-9 ]/g, "")
                  );
                }}
                defaultValue={props.name}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblCode" class="col-sm-4 col-form-label">
              Generated Brokerage Code
            </label>
            <div class="col-sm-8">
              <label id="txtCode">
                {props.code ? props.code : code ? code : ""}
              </label>
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblFormID" class="col-sm-4 col-form-label">
              Form IDs
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtFormID"
                placeholder="Enter comma-separated Form IDs"
                onChange={(event) => {
                  setFormID(event.target.value);
                }}
                defaultValue={props.formIDs}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblAddr1" class="col-sm-4 col-form-label">
              Address Line 1
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtAddr1"
                placeholder="Enter Address Line 1"
                onChange={(event) => {
                  setAddr1(event.target.value);
                }}
                defaultValue={props.addr1}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblAddr2" class="col-sm-4 col-form-label">
              Address Line 2
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtAddr2"
                placeholder="Enter Address Line 2"
                onChange={(event) => {
                  setAddr2(event.target.value);
                }}
                defaultValue={props.addr2}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblCity" class="col-sm-4 col-form-label">
              City
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtCity"
                placeholder="Enter City"
                onChange={(event) => {
                  setCity(event.target.value);
                }}
                defaultValue={props.city}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblProvince" class="col-sm-4 col-form-label">
              Province
            </label>
            <div class="col-sm-8">
              <Select
                placeholder={"Select Province"}
                color={theme.COLORS.primary_navyblue}
                searchable={true}
                onChange={(values) => onProvinceHandle(values)}
                values={[]}
                options={provinceValue}
                style={{
                  width: "100%",
                  height: "5vh",
                  fontSize: "1.9vmin",
                  border: "5px solid white",
                  borderRadius: 15,
                  fontFamily: "GibsonRegular",
                }}
                labelField={"name"}
                valueField={"code"}
                dropdownHeight={"58vh"}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblPostalCode" class="col-sm-4 col-form-label">
              Postal Code
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtPostalCode"
                placeholder="Enter Postal Code"
                onChange={(event) => {
                  setPostalCode(event.target.value);
                }}
                defaultValue={props.postalCode}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblWebsite" class="col-sm-4 col-form-label">
              Website
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtWebsite"
                placeholder="Enter Website"
                onChange={(event) => {
                  setWebsite(event.target.value);
                }}
                defaultValue={props.website}
              />
            </div>
          </div>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblPhone" class="col-sm-4 col-form-label">
              Phone Number
            </label>
            <div class="col-sm-8">
              <input
                class="form-control"
                id="txtPhone"
                placeholder="Enter Phone Number"
                onChange={(event) => {
                  setPhone(event.target.value);
                }}
                defaultValue={props.phone}
              />
            </div>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              onChange={(event) => {
                setCheck(event.target.checked);
              }}
              id="flexCheckDefault"
            />
          </div>
          <label
            for="lblPhone"
            class="col-sm-4 col-form-label"
            style={{ fontSize: "1.6vh", padding: "0px", marginLeft: "1.3rem" }}
          >
            Allow Free Subscription
          </label>
          <div
            class="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          ></div>
          <div class="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onAddButtonClick();
              }}
            >
              Add
            </Button>
          </div>
          <div class="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

const InsurerContactItems = () => {
  const dispatch = useDispatch();
  let history = useNavigate();
  const brokerages = useSelector(getBrokeragesList);
  const usercounts = useSelector(getBrokeragesUserCounts);
  return (
    <div
      className="m-4"
      style={{
        fontFamily: "GibsonRegular",
        fontSize: "0.8vw",
        justifyContent: "center",
      }}
    >
      <table className="table table-sm">
        <thead>
          <tr>
            <th scope="col">Brokerage Name</th>
            <th scope="col">Active Users</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {brokerages ? (
            brokerages.map((item) => {
              return (
                <Fragment key={item.code}>
                  <tr scope="row" className="thead-light">
                    <th scope="row">{item.name}</th>
                    <th scope="row">
                      {item.code in (usercounts ? usercounts : [])
                        ? usercounts[item.code]
                        : 0}
                    </th>
                    <th scope="row">
                      {(item.code in (usercounts ? usercounts : [])
                        ? usercounts[item.code]
                        : 0) > 0
                        ? "Active"
                        : "Inactive"}
                    </th>
                    <th scope="row">
                      <Button
                        style={{
                          justifyContent: "center",
                          color: "white",
                          fontFamily: "GibsonRegular",
                          fontSize: 10,
                          backgroundColor: theme.COLORS.secondary_orange,
                          border: 0,
                          letterSpacing: 1,
                        }}
                        onClick={() => {
                          history(
                            "/quoteyadmin/details?c=" +
                              encodeURIComponent(item.code)
                          );
                        }}
                      >
                        Edit Brokerage
                      </Button>
                    </th>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BrokerageSuperAdminDashboard;
